// Contact is assembled at runtime so the full address is not a single
// harvestable string in static HTML attributes.
const LOCAL = ['info'].join('');
const DOMAIN = ['elmbsol', 'com'].join('.');

export function getContactEmail() {
  return `${LOCAL}@${DOMAIN}`;
}

export function getStrategyReviewMailto({
  name = '',
  email = '',
  organization = '',
  interest = '',
  message = ''
} = {}) {
  const subject = interest || 'Technology Strategy Review';
  const lines = [
    name && `Name: ${name}`,
    email && `Email: ${email}`,
    organization && `Organization: ${organization}`,
    interest && `Interest: ${interest}`,
    message && `Message:\n${message}`
  ].filter(Boolean);

  const body = lines.length
    ? lines.join('\n\n')
    : 'I would like to schedule a Technology Strategy Review.';

  return `mailto:${getContactEmail()}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}

export function openStrategyReviewMailto(fields) {
  window.location.href = getStrategyReviewMailto(fields);
}
